export default __webpack_public_path__ + "assets/53fca96094be4544251e152127c48b2d/3-things-to-consider-for-your-next-usc-off-campus-rental.jpg";